// extracted by css-extract-rspack-plugin
export default {"dismissalCommentTextarea":"BaseSharedDismissalDialog-module__dismissalCommentTextarea__zsW4E"};